import axios from 'axios';
import { SubPlantOperationsDto, AllSubPlantOperationsModel, SubPlantOperationsResponseModel, ProductionLogDetailsResponseModel } from '@gtpl/shared-models/production-management';
import { SubPlantCodesEnum, PlantsEnum, OperationTypeEnum, JobStatusEnum, UnitRequest } from '@gtpl/shared-models/common-models';
import connection from './connection';
import { CommonResponse } from '@gtpl/shared-models/masters';

export class SubPlantOperationsService {
    URL = connection.DEPLOY_URL + '/prod-log';

    async getAllSubPlantOperations(req:UnitRequest): Promise<ProductionLogDetailsResponseModel> {
        return await axios.post(this.URL + '/getSubPlantHistoryDetails',req)
            .then(res => {
                return res.data
            })
    }
    async getTransactionDetails(req:UnitRequest): Promise<CommonResponse> {
        return await axios.post(this.URL + '/getSubPlantHistoryDetails',req)
            .then(res => {
                return res.data
            })
    }
}